import { apiRequest } from '@/plugins/api.js';
import { apiResponseTypeEnum } from '@/constants/api.js';
import { bonusPhaseTypeEnum } from '@/constants/bonusPhase.js';

export const apiRetrieveBonusPhases = () => apiRequest({
  url: 'api/getBonusPhases',
  method: 'POST',
}).then((response) => {
  const responseEnum = response?.data?.responseEnum;
  const responseData = response?.data?.data;

  if (responseEnum !== apiResponseTypeEnum.OPERATION_SUCCESS) {
    return Promise.reject({ responseEnum });
  } else if (!Array.isArray(responseData) || responseData.length === 0) {
    return Promise.reject({ responseEnum: 'EMPTY_DATA' });
  }

  const formatedData = responseData.map((data) => {
    let __type = '';

    if (data.type === 'BUNDLES' && !data.dailyBonusType) {
      __type = bonusPhaseTypeEnum.BUNDLES;
    } else if (data.type === 'POINTS' && !data.dailyBonusType) {
      __type = bonusPhaseTypeEnum.POINTS;
    } else if (
      !['BUNDLES', 'POINTS'].includes(data.type) &&
      data.dailyBonusType &&
      !['PUZZLE', 'LIGHT_THE_LANTERNS'].includes(data.dailyBonusType)
    ) {
      __type = bonusPhaseTypeEnum.DAILY;
    }

    return {
      ...data,
      __type,
    };
  });

  const puzzleBonusGame = responseData.find(({ dailyBonusType }) => (dailyBonusType === 'PUZZLE'));
  const lanternBonusGame = responseData.find(({ dailyBonusType }) => (dailyBonusType === 'LIGHT_THE_LANTERNS'));

  const bundleList = formatedData.filter(({ __type }) => __type === bonusPhaseTypeEnum.BUNDLES);
  const pointsList = formatedData.filter(({ __type }) => __type === bonusPhaseTypeEnum.POINTS);
  const dailyList = formatedData.filter(({ __type }) => __type === bonusPhaseTypeEnum.DAILY);

  return {
    parsedData: [...bundleList, ...pointsList, ...dailyList], // maintaining the order of bundles, points, and daily
    hasDailyReward: dailyList.length > 0,
    puzzleBonusGame,
    lanternBonusGame,
  };
});
